import {API} from 'aws-amplify'
import {UserModel} from '../../auth'

export const getBatchStatus = async (currentUser: UserModel) => {
  return API.get('app_base', `/organization/${currentUser.currentOrganization}/batchstatus`, {})
}
